import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import Draggable from 'react-draggable';

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #fff;
  color: #000;
  overflow: hidden;
`;

const Instruction = styled.div`
  margin-bottom: 10px;
  font-size: 16px;
  text-align: center;
`;

const BoxContainer = styled.div`
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  position: absolute;
  width: ${props => props.width || '60%'};
  height: ${props => props.height || '100%'};
  background-color: transparent;
  border: 1px solid #000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const CenterBox = styled.div`
  position: absolute;
  width: 3%;
  height: 50%;
  background: linear-gradient(black, grey, #F0F0F0);
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const Label = styled.div`
  color: ${props => (props.newLabel ? 'black' : 'white')};
  font-size: 15px;
  transform: rotate(-90deg);
  margin: 17px;
`;

const Image = styled.img`
  width: auto;
  height: 50px;
  position: absolute;
  transition: transform 0.2s, filter 0.2s;

  &.stretched {
    transform: scale(1.2, 0.8); /* 비율을 찌그러뜨리는 효과 */
  }
`;

const DraggableImage = ({ src, alt, defaultPosition, onDragEnter, onStop, stretched }) => {
  const handleStart = (event) => {
    event.preventDefault();
  };

  return (
    <Draggable onStart={handleStart} onStop={onStop}>
      <div style={{ position: 'absolute', top: defaultPosition.top, left: defaultPosition.left }}>
        <Image src={src} alt={alt} className={stretched ? 'stretched' : ''} onDragEnter={onDragEnter} />
      </div>
    </Draggable>
  );
};

const Home = () => {
  const getRandomPosition = (isLeft) => {
    const x = isLeft ? Math.random() * 13.5 : 80 + Math.random() * 14;
    const y = Math.random() * 70 + 5;
    return { top: `${y}vh`, left: `${x}vw` };
  };

  const images = Array.from({ length: 193 }, (_, i) => ({
    src: `${process.env.PUBLIC_URL}/images/image${i + 1}.jpeg`,
    id: i,
  }));

  const [positions] = useState(
    images.map((_, i) => {
      const isLeft = i % 2 === 0;
      return getRandomPosition(isLeft);
    })
  );

  const [stretchedImages, setStretchedImages] = useState({}); // stretched 상태를 저장하는 state

  const boxRefs = {
    boxA: useRef(null),
    boxB: useRef(null),
    boxC: useRef(null),
    boxD: useRef(null),
    yellowBox: useRef(null) // 노란색 박스를 위한 참조
  };

  const handleDragEnter = (e, id) => {
    const yellowBoxRect = boxRefs.yellowBox.current.getBoundingClientRect();
    const imageCenterX = e.clientX;
    const imageCenterY = e.clientY;

    if (
      imageCenterX > yellowBoxRect.left &&
      imageCenterX < yellowBoxRect.right &&
      imageCenterY > yellowBoxRect.top &&
      imageCenterY < yellowBoxRect.bottom
    ) {
      setStretchedImages(prev => ({ ...prev, [id]: true })); // 비율을 찌그러뜨리는 효과 적용
    }
  };

  const handleDrop = (e, data, id) => {
    setStretchedImages(prev => ({ ...prev, [id]: true })); // 비율을 찌그러뜨리는 효과 적용
  };

  return (
    <HomeContainer>
      <Instruction>이미지를 풍화 나이테 위에 놓아보세요. 나만의 관심사 백과사전을 만들어보세요!</Instruction>
      <BoxContainer>
        <Box className="boxA" ref={boxRefs.boxA} width="60%" height="100%" /> {/* 박스 A */}
        <Box className="boxB" ref={boxRefs.boxB} width="40%" height="70%" /> {/* 박스 B */}
        <Box className="boxC" ref={boxRefs.boxC} width="20%" height="50%" /> {/* 박스 C */}
        <Box className="boxD" ref={boxRefs.boxD} width="10%" height="20%" /> {/* 박스 D */}
        <Box className="yellowBox" ref={boxRefs.yellowBox} width="60%" height="100%" style={{ backgroundColor: 'yellow', opacity: 0, pointerEvents: 'none' }} /> {/* 노란색 박스 */}
        <CenterBox>
          <Label>OLD</Label>
          <Label newLabel>NEW</Label>
        </CenterBox>
        {images.map((image, index) => (
          <DraggableImage
            key={image.id}
            src={image.src}
            alt={`image-${image.id}`}
            defaultPosition={positions[index]}
            onDragEnter={(e) => handleDragEnter(e, image.id)} // 드래그 진입 이벤트 처리
            onStop={(e, data) => handleDrop(e, data, image.id)} // 드롭 이벤트 처리
            stretched={stretchedImages[image.id]} // stretched 상태 전달
          />
        ))}
      </BoxContainer>
    </HomeContainer>
  );
};

export default Home;
